import { VALUE_TYPES } from '../data';
import { typeOf } from '../typeOf';
import type { InstanceClone } from '../types';
import { cloneArrayDeep } from './cloneArrayDeep';
import { cloneObjectDeep } from './cloneObjectDeep';
import { cloneShallow } from './cloneShallow';

/**
 * Recursively (deep) clones native types, like Object, Array, RegExp, Date, Map, Set, Symbol, Error as well as primitives.
 */
export function clone<T>(
  value: T,
  instanceClone: InstanceClone<T> = false,
): T {
  const type = typeOf(value);

  switch (type) {
    case VALUE_TYPES.object: {
      return cloneObjectDeep(value, instanceClone);
    }

    case VALUE_TYPES.array:
    case VALUE_TYPES.int8array:
    case VALUE_TYPES.uint8array:
    case VALUE_TYPES.uint8clampedarray:
    case VALUE_TYPES.int16array:
    case VALUE_TYPES.uint16array:
    case VALUE_TYPES.int32array:
    case VALUE_TYPES.uint32array:
    case VALUE_TYPES.float32array:
    case VALUE_TYPES.float64array:
    case VALUE_TYPES.bigint64array:
    case VALUE_TYPES.biguint64array: {
      return cloneArrayDeep(value, instanceClone);
    }

    default: {
      return cloneShallow(value);
    }
  }
}
